export default __webpack_public_path__ + "static/dc-island-81795846ef189236ef06bbd90b9e4713.png";